import { InstructionComponentProps } from "../InstructionComponent"
import SmallestHeadingComponent from "../../SmallestHeadingComponent"

import IMG_1 from "../../../resources/tutorial/report_page_1.png"
import IMG_2 from "../../../resources/tutorial/report_page_2.png"
import IMG_3 from "../../../resources/tutorial/report_page_3.png"

const ReportStructureInstruction: InstructionComponentProps = {
    name: "Wie ist der wöchentliche Bericht strukturiert?",
    path: "/help/professional/report",
    description: (
        <>
            Als Ärzt:in wird Ihnen einmal wöchentlich (Sonntag 20:00 Uhr) ein
            Bericht pro Patient:in per Mail zugesendet. Dieser Bericht enthält
            eine Übersicht über die gesammelten Daten und Fragebögen der letzten
            zwei Wochen der Patient:innen, sodass Sie sich schnell einen
            Überblick über den Verlauf der Therapie verschaffen können.
        </>
    ),
    custom: (
        <div className={"flex flex-col space-y-4"}>
            <div>
                <SmallestHeadingComponent>Seite 1</SmallestHeadingComponent>
                <div>
                    Die erste Seite des Berichts enthält allgemeine
                    Informationen zum Patienten sowie die letzten zwei
                    Ergebnisse des PHQ-8-Fragebogens, einschließlich der
                    Stimmungs- und Schritterfassung. Unterhalb der persönlichen
                    Informationen finden Sie in blauer Schrift den Zeitraum,
                    über den der Bericht zusammenfasst. Darunter sind die
                    letzten zwei Ergebnisse des PHQ-8-Fragebogens aufgeführt,
                    und die Legende auf der rechten Seite bietet
                    Interpretationshilfen zu diesen Ergebnissen. Zur relativen
                    Einordnung der Ergebnisse sind zudem die Durchschnittswerte
                    der letzten 90 und 14 Tage angegeben. Unterhalb der
                    PHQ-8-Ergebnisse finden Sie die Stimmungs- und
                    Schritterfassung der letzten 14 Tage. Die x-Achse zeigt die
                    Tage an, während die y-Achse die Anzahl der Schritte bzw.
                    die Stimmung des Patienten darstellt. Unterhalb der Graphen
                    sind außerdem die Durchschnittswerte der letzten 90 und 14
                    Tage aufgeführt. Diese Durchschnittswerte sind im Graphen
                    durch gestrichelte Linien markiert: die blaue Linie steht
                    für den Durchschnitt der letzten 90 Tage, die graue Linie
                    für den Durchschnitt der letzten 14 Tage.
                </div>
                <img src={IMG_1} />
            </div>
            <div>
                <SmallestHeadingComponent>Seite 2</SmallestHeadingComponent>
                <div>
                    Die zweite Seite des Berichts enthält Daten zur Schlafdauer,
                    Einschlafdauer und zur Herzfrequenz bei Nacht. Die
                    x-Achse repräsentiert die Tage, während die y-Achse die
                    Dauer in Stunden bzw. die Herzfrequenz bei Nacht anzeigt. Die blaue
                    gestrichelte Linie steht für den Durchschnitt der letzten 90
                    Tage, die graue gestrichelte Linie für den Durchschnitt der
                    letzten 14 Tage. Beide Werte sind zudem unter den Graphen
                    aufgeführt.
                </div>
                <img src={IMG_2} />
            </div>
            <div>
                <SmallestHeadingComponent>Seite 3</SmallestHeadingComponent>
                <div>
                    Die dritte Seite des Berichts enthält Daten zur
                    Herzfrequenzvariabilität bei Nacht. Die x-Achse zeigt die
                    Tage an, während die y-Achse die Herzfrequenzvariabilität bei Nacht
                    darstellt. Die blaue gestrichelte Linie entspricht dem
                    Durchschnitt der letzten 90 Tage, die graue gestrichelte
                    Linie dem Durchschnitt der letzten 14 Tage. Beide Werte sind
                    außerdem unter den Graphen aufgeführt.
                </div>
                <img src={IMG_3} />
            </div>
        </div>
    )
}

export default ReportStructureInstruction
